import { atomWithKey as atom } from "./atomWithKey";
import { atom as jotaiAtom } from "jotai";
import { IPassenger } from "../Types/Index";
import {
  IAdditionalPassenger, ICustomerContact, IPassengerSelection,
  ISelectedPassengerForCancelIds, ISubPassenger, IUserResponse, ISelectedPassenger
} from "../Types/Index";
import { searchStateAtom } from "./atoms";

export const passengerTypesStateAtom = atom<IPassengerSelection[]>({
  key: 'passengerTypesStateAtom',
  default: [],
});

export const passengerStateAtom = atom<IPassenger[]>({
  key: "passengerStateAtom",
  default: [],
});

export const selectedPassengersPerTypeStateAtom = atom<{ [key: number]: string | null }>({
  key: "selectedPassengersPerTypeStateAtom",
  default: {},
});


export const customerContactStateAtom = atom<ICustomerContact>({
  key: "customerContactStateAtom",
  default: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  },
});

export const savedPassengerDetailAtom = atom<IAdditionalPassenger[]>({
  key: "savedPassengerDetailAtom",
  default: []
});

export const checkoutUserDataAtom = atom<IUserResponse | null>({
  key: "checkoutUserDataAtom",
  default: null
});

export const passengerMappingAtom = atom<ISubPassenger[]>({
  key: "passengerMappingAtom",
  default: []
});

export const areAllPassengerDetailsCompleteAtom = atom<boolean>({
  key: "areAllPassengerDetailsCompleteAtom",
  default: false
});

export const selectedPassengerForCancelAtom = atom<ISelectedPassengerForCancelIds[]>(
  {
    key: "selectedPassengerForCancelAtom",
    default: [],
  }
);

export const selectedPassengerForCancelInBoundAtom = atom<ISelectedPassengerForCancelIds[]>(
  {
    key: "selectedPassengerForCancelInBoundAtom",
    default: [],
  }
);

export const selectedPassengersAtom = atom<ISelectedPassenger[]>({
  key: "selectedPassengersAtom",
  default: [],
});

export const totalPassengersSelectorAtom = jotaiAtom((get) => {
    const search = get(searchStateAtom);
    const passengers = search.passengers;

    let totalWithoutInfants = 0;
    let totalWithInfants = 0;
    let selectedPassengerTypes = 0;
    let totalPassengerCount = 0;
    // Create formatted passenger count strings
    const passengerStrings: string[] = [];
    const passengerCounts: Record<string, number> = {};

    // Helper function to return a formatted label for each passenger type
    const getPassengerLabel = (key: string, count: number) => {
      switch (key) {
        case 'adults':
          return `${count} ${count === 1 ? 'adult' : 'adults'}`;
        case 'children':
          return `${count} ${count === 1 ? 'child' : 'children'}`;
        case 'seniorcitizens':
          return `${count} ${count === 1 ? 'senior citizen' : 'senior citizens'}`;
        case 'students':
          return `${count} ${count === 1 ? 'student' : 'students'}`;
        case 'reducedMobility':
          return `${count} person${count > 1 ? 's' : ''} with reduced mobility`;
        case 'wheelchair':
          return `${count} wheelchair user${count > 1 ? 's' : ''}`;
        case 'infants':
          return `${count} ${count === 1 ? 'infant' : 'infants'}`;
        default:
          return `${count} ${key}`; // Fallback if new types are added
      }
    };

    // Loop through passenger types and counts
    for (const key in passengers) {
      const count = passengers[key];
      if (count > 0) {
        passengerCounts[key] = count;

        if (key === 'infants') {
          totalWithInfants += count;
          //passengerStrings.push(getPassengerLabel(key, count));
        } else {
          totalWithoutInfants += count;
          totalWithInfants += count;
          selectedPassengerTypes += 1;
          const label = getPassengerLabel(key, count);
          passengerStrings.push(label);
        }
      }
      totalPassengerCount += count;
    }

    // Determine the passenger summary based on the conditions
    let passengerSummary;
    if (selectedPassengerTypes === 1) {
      // If only one type is selected, show the detailed label
      passengerSummary = passengerStrings[0];
    } else {
      // If more than one type is selected, show the total count and "passengers"
      passengerSummary = `${totalWithoutInfants} passenger${totalWithoutInfants > 1 ? 's' : ''}`;
    }
    return {
      totalWithoutInfants,
      totalWithInfants,
      passengerSummary,
      passengerCounts,
      totalPassengerCount
    };
});
totalPassengersSelectorAtom.debugLabel = "totalPassengersSelectorAtom";

export const passengerSeatCursorAtom = atom<string[]>({
  key: "passengerSeatCursorAtom",
  default: []
});
export const changeTripAlreadyPaidAddonsAtom = atom<any>({
  key: "changeTripAlreadyPaidAddonsAtom",
  default: {}
});